<h1 class="h3">Repositories</h1>
<ul class="list-unstyled">
  <li *ngFor="let item of data">
    <a routerLink="/repositories/{{item}}">{{item}}</a>
  </li>
</ul>
